import {useCallback, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import imgAnimalitos from "@/assets/images/carrousel categorias principales/ANIMALITOS.jpg";
import imgBingo from "@/assets/images/carrousel categorias principales/BINGO.jpg";
import imgHorses from "@/assets/images/carrousel categorias principales/CABALLOS.jpg";
import imgLiveCasino from "@/assets/images/carrousel categorias principales/CASINO-EN-VIVO.jpg";
import imgSports from "@/assets/images/carrousel categorias principales/DEPORTES.jpg";
import imgEsports from "@/assets/images/carrousel categorias principales/E-SPORTS.jpg";
import imgMiniGames from "@/assets/images/carrousel categorias principales/MINI-JUEGOS.jpg";
import imgPlinko from "@/assets/images/carrousel categorias principales/PLINKO.jpg";
import imgSlots from "@/assets/images/carrousel categorias principales/SLOTS.jpg";
import {Carousel} from "@/components";
import styles from "./GameCategoriesCarousel.module.css";

const GAME_CATEGORIES = [
  {
    id: "slots",
    labelKey: "categorySlots",
    defaultLabel: "Slots",
    icon: "🎰",
    path: "/gameslist/all",
    image: imgSlots,
  },
  {
    id: "live-casino",
    labelKey: "categoryLiveCasino",
    defaultLabel: "Casino en Vivo",
    icon: "🃏",
    path: "/casino",
    image: imgLiveCasino,
  },
  {
    id: "sports",
    labelKey: "categorySports",
    defaultLabel: "Deportes",
    icon: "⚽",
    path: "/sports",
    image: imgSports,
  },
  {
    id: "horses",
    labelKey: "categoryHorses",
    defaultLabel: "Caballos",
    icon: "🏇",
    path: "/horses",
    image: imgHorses,
  },
  {
    id: "bingo",
    labelKey: "categoryBingo",
    defaultLabel: "Bingo",
    icon: "🎯",
    path: "/bingo",
    image: imgBingo,
  },
  {
    id: "mini-games",
    labelKey: "categoryMiniGames",
    defaultLabel: "Mini Juegos",
    icon: "🕹️",
    path: "/mini-juegos",
    image: imgMiniGames,
  },
  {
    id: "animalitos",
    labelKey: "categoryAnimalitos",
    defaultLabel: "Animalitos",
    icon: "🐾",
    path: "/lottery",
    image: imgAnimalitos,
  },
  {
    id: "plinko",
    labelKey: "categoryPlinko",
    defaultLabel: "Plinko",
    icon: "🔴",
    scrollTo: "plinko-carousel",
    image: imgPlinko,
  },
  {
    id: "esports",
    labelKey: "categoryEsports",
    defaultLabel: "E-Sports",
    icon: "🎮",
    path: "/games/pragmatic/vplobby",
    image: imgEsports,
  },
];

const GameCategoriesCarousel = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const carouselControlsRef = useRef(null);

  const handleCategoryClick = useCallback(
    category => {
      if (category.scrollTo) {
        const el = document.getElementById(category.scrollTo);
        if (el) {
          el.scrollIntoView({behavior: "smooth", block: "center"});
          return;
        }
      }
      navigate(category.path);
    },
    [navigate]
  );

  const handleCarouselInit = useCallback(controls => {
    carouselControlsRef.current = controls;
  }, []);

  return (
    <div className={styles.wrapper}>
      <Carousel
        speed={0.5}
        pauseOnHover
        onInit={handleCarouselInit}
      >
        {GAME_CATEGORIES.map(category => (
          <button
            key={category.id}
            type="button"
            className={styles.card}
            onClick={() => handleCategoryClick(category)}
            aria-label={t(category.labelKey, {defaultValue: category.defaultLabel})}
          >
            <div className={styles.cardImageWrap}>
              <img
                src={category.image}
                alt={t(category.labelKey, {defaultValue: category.defaultLabel})}
                className={styles.cardImage}
                loading="lazy"
              />
              <div className={styles.cardOverlay} />
              <span className={styles.cardLabel}>{t(category.labelKey, {defaultValue: category.defaultLabel})}</span>
            </div>
          </button>
        ))}
      </Carousel>
    </div>
  );
};

export default GameCategoriesCarousel;
